<template>
  <row>
    <column class="col-md-12">
      <va-box title="Settings"
              theme="box-info"
              :isBorder="true"
              widgetType="">
        <div slot="content">
          <va-input-group groupType="input"
                          placeholder="Username"
                          prefixAddonText="@">
          </va-input-group>
          <br />
          <va-input-group groupType="input"
                          suffixAddonText=".00">
          </va-input-group>
          <br />
          <va-input-group groupType="input"
                          prefixAddonText="$"
                          suffixAddonText=".00">
          </va-input-group>
          <br />
          <va-input-group groupType="input"
                          placeholder="Email"
                          type="email">
            <i slot="slotPrefixAddonText" class="fa fa-envelope"></i>
          </va-input-group>
          <br />
          <va-input-group groupType="input">
            <i slot="slotSuffixAddonText" class="fa fa-check"></i>
          </va-input-group>
          <br />
          <va-input-group groupType="input">
            <i slot="slotPrefixAddonText" class="fa fa-dollar"></i>
            <i slot="slotSuffixAddonText" class="fa fa-ambulance"></i>
          </va-input-group>
          <br />
        </div>
        <div slot="footer">
          <va-button :isBlock="false" theme="danger" name="Cancel" align="right"></va-button>
          <va-button :isBlock="false" theme="success" align="right" name="Save" style="margin-right: 10px;"></va-button>
        </div>
      </va-box>
    </column>
  </row>
</template>
<script>
  import VABox from '../widgets/VABox'
  import VAInputGroup from '../components/VAInputGroup'
  import VACheckBox from '../components/VACheckBox'
  import VAInput from '../components/VAInput'
  import VAButton from '../components/VAButton'
  import VATextareaGroup from '../components/VATextareaGroup'
  import VAFormGroup from '../components/VAFormGroup'
  import VARadio from '../components/VARadio'
  import VASelect from '../components/VASelect'

  export default {
    name: 'settingsAdmin',
    components: {
      'va-box': VABox,
      'va-input-group': VAInputGroup,
      'va-checkbox': VACheckBox,
      'va-input': VAInput,
      'va-button': VAButton,
      'va-textarea-group': VATextareaGroup,
      'va-form-group': VAFormGroup,
      'va-radio': VARadio,
      'va-select': VASelect
    },
    data () {
      return {
        selectList: [
          'option1',
          'option2',
          'option3',
          'option4',
          'option5'
        ]
      }
    },
    created () {
      this.$root.title = 'Settings'
    },
    methods: {
    }
  }
</script>




// WEBPACK FOOTER //
// SettingsAdmin.vue?b6fd3804